import { useCallback, useEffect, useRef, useState } from 'react'

import { AxiosResponse } from 'axios'
import { AxiosCall } from 'models'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

export const useFetchAndLoad = () => {
  const { t } = useTranslation('errors')
  const [loading, setLoading] = useState(false)
  const controllerRef = useRef<AbortController | null>(null)

  const callEndpoint = useCallback(
    async (axiosCall: AxiosCall<any>) => {
      if (axiosCall.controller) controllerRef.current = axiosCall.controller
      setLoading(true)
      let result = {} as AxiosResponse<any>
      try {
        result = await axiosCall.call
      } catch (error: any) {
        if (error.response?.data && error.response.status < 500) {
          const err = error.response.data
          if (typeof err === 'object' && err !== null) {
            for (const prop in err) {
              toast.error(`${t(prop)}: ${err[prop]}`)
            }
          }
          setLoading(false)
          throw error
        }
        if (error.response?.data && error.response.status === 500) {
          throw error
        }
      }
      setLoading(false)
      return result
    },
    [t]
  )

  const cancelEndpoint = useCallback(() => {
    setLoading(false)
    controllerRef.current && controllerRef.current.abort()
  }, [])

  useEffect(() => {
    return () => {
      cancelEndpoint()
    }
  }, [cancelEndpoint])

  return { loading, callEndpoint }
}
